import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "./DrawerCom"

import { PaddingLeftRightWrap, ScrollBoxWrap, ScrollOutBoxWrap } from "./DrawerStyle"
import { useCallback, useEffect, useState } from "react"

import BestDealCom from "components/BestDealCom"

import cardIcon from 'assets/images/card_best_deal.png'
import lowFeesIcon from 'assets/images/low_fees_best_deal.png'
import liquidityIcon from 'assets/images/liquidity_best_deal.png'
import topSpeedIcon from 'assets/images/top_speed_best_deal.png'
import sweetSpotIcon from 'assets/images/sweet_spot_best_deal.png'
import { motion } from "framer-motion"
import { Row } from "style/preset"
import BorderBtnCom from "components/BorderBtnCom"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerBestDealCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源

        } else {
            // 清理资源

        }
    }, [open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = () => {
        onComplete();
        fnCloseWin()
    }

    const fnOpenMedium = () => {
        const url = ``
        window.open(url, '_blank')
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap>
            <PaddingLeftRightWrap>
                <StyledContainer $display="inline-flex">
                    <BestDealCom></BestDealCom>
                </StyledContainer>
                <StyledContainer $height="20px"></StyledContainer>
                <StyledContainer $fontSize="22px" $lineHeight="1" $fontWeight6 $roobertSemiBold>Our commitment</StyledContainer>
                <StyledContainer $mt="10px" $fontSize="16px" $lineHeight="20px" $fontWeight6 $roobertSemiBold>Chainge stands out as the best deal on the market.</StyledContainer>
                <StyledContainer $mb="16px" $fontSize="16px" $lineHeight="20px" $fontWeight6 $roobertSemiBold>How?</StyledContainer>
            </PaddingLeftRightWrap>
            <ScrollOutBoxWrap>
                <ScrollBoxWrap>
                    <StyledContainer $fontSize="14px" $lineHeight="18px" $fontWeight5>By providing the most competitive prices primarily attributed to its remarkably low fees and ability to access cross-chain liquidity.</StyledContainer>
                    
                    <StyledContainer $position="relative" $height="8.5vw" $mt="40px" $mb="40px">
                        <AnimateImgWrap src={lowFeesIcon} 
                            animate={{
                                top: ["0vw", "1vw", "0vw"],
                                left: ["0vw", "1.5vw", "0vw"],
                            }}
                            transition={{
                                duration: 5,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        ></AnimateImgWrap>
                        <AnimateImgWrap src={cardIcon}
                            animate={{
                                bottom: ["0vw", "1.5vw", "0vw"],
                                right: ["2.5vw", "5vw", "2.5vw"],
                            }}
                            transition={{
                                duration: 6,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        ></AnimateImgWrap>
                        <AnimateImgWrap src={liquidityIcon}
                            animate={{
                                top: ["0vw", "1.5vw", "0vw"],
                                right: ["0vw", "2vw", "0vw"],
                            }}
                            transition={{
                                duration: 5,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        ></AnimateImgWrap>
                        <AnimateImgWrap src={topSpeedIcon}
                            animate={{
                                bottom: ["0vw", "1vw", "0vw"],
                                left: ["3vw", "5vw", "3vw"],
                            }}
                            transition={{
                                duration: 4.5,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        ></AnimateImgWrap>

                        <AnimateImgCenterWrap src={sweetSpotIcon}
                            animate={{
                                height: ["8vw", "10vw", "8vw"],
                            }}
                            transition={{
                                duration: 6,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        ></AnimateImgCenterWrap>
                    </StyledContainer>

                    <StyledContainer $mb="20px" $fontSize="14px" $lineHeight="18px" $fontWeight4 $roobertRegular>While other aggregators and DEXs may appear to offer slightly higher outputs for small tx's, the separate fees charged for gas are consistently higher compared to Chainge's rates and not included in the output amount. </StyledContainer>

                    <StyledContainer $mb="30px" $fontSize="14px" $lineHeight="18px" $fontWeight6 $roobertSemiBold>This distinction ensures that you experience a much more favorable and transparent pricing structure when engaging with our dApp.</StyledContainer>
                </ScrollBoxWrap>
            </ScrollOutBoxWrap>
            <PaddingLeftRightWrap>
                <Row>
                    <BorderBtnCom label="Ok, I got it" iconIndex="1" showIcon={true} onClick={fnCloseWin}></BorderBtnCom>
                    <StyledContainer $width="10px"></StyledContainer>
                    <BorderBtnCom label="Read more on Medium" iconIndex="2" showIcon={true} type="black" onClick={fnOpenMedium}></BorderBtnCom>
                </Row>
            </PaddingLeftRightWrap>
  
        </DrawerContentWrap>
    </DrawerCom> : <></>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

const ImgWrap = styled.img<{}>`
  position: absolute;
  height: 4vw;
`;

const AnimateImgWrap = styled(motion(ImgWrap))``;
const AnimateImgCenterWrap = styled(motion(ImgWrap))`
    height: 8vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;


export default DrawerBestDealCom